import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestFeedbackPost = {
    path: "/feedback/:slug",
    method: RouteHttpVerb.POST
};
export { locationRestFeedbackPost };
